import type { IAddress } from '@common/utils/getFormattedAddress';
import { FormParagraphFormGroup } from '@frontend/components/fields/FormParagraphField';
import { getSelectedLanguage } from '@frontend/translate';
import { getCountryName } from '@frontend/utils/countriesUtils';

export function AddressFormGroupFormParagraph(props: { address: IAddress }) {
    const { address } = props;

    const translate = getSelectedLanguage();
    const houseNumberAndAdditions = `${address.houseNumber ?? ''} ${address.houseLetter ?? ''} ${
        address.houseNumberSuffix ?? ''
    }`;

    return (
        <>
            <FormParagraphFormGroup label={translate.common.street}>{address.street}</FormParagraphFormGroup>
            <FormParagraphFormGroup label={translate.common.houseNumber}>
                {houseNumberAndAdditions}
            </FormParagraphFormGroup>
            <FormParagraphFormGroup label={translate.common.zipcode}>{address.zip}</FormParagraphFormGroup>
            <FormParagraphFormGroup label={translate.common.city}>{address.city}</FormParagraphFormGroup>
            <FormParagraphFormGroup label={translate.common.country}>
                {getCountryName(address.country)}
            </FormParagraphFormGroup>
        </>
    );
}
